<template>
  <div class="loading">
    <img src="@/assets/progress.gif" />
  </div>
</template>

<script>
export default {
  name: "Loading"
}
</script>

<style lang="scss">
  .loading {
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: flex-start;
    justify-content: center;
    top: 0px;
    left: 0px;
    img {
      margin-top: 100px;
      max-width: 50px;
    }
  }
</style>